import { ILoadingCellRendererAngularComp } from 'ag-grid-angular';
import { ILoadingCellRendererParams } from 'ag-grid-community';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'grid-ui-loading-renderer',
  templateUrl: './loading-renderer.component.html',
  styleUrls: ['./loading-renderer.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LoadingRendererComponent implements ILoadingCellRendererAngularComp {
  public params!: ILoadingCellRendererParams & { loadingMessage: string };

  public agInit(params: ILoadingCellRendererParams & { loadingMessage: string }): void {
    this.params = params;
  }
}
